import React, { useState } from 'react';
import '../styles/Modal.css';

const stickers = ['😀', '❤️', '👍', '🔥', '🎉', '😢', '📚', '🚀', '🎓', '📝'];




function CreatePostModal({ isOpen, onClose, onPostCreated }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) {
      setError('Gönderi içeriği boş olamaz.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await onPostCreated(content);
      setContent('');
      onClose();
    } catch (err) {
      setError(err.message || 'Gönderi oluşturulamadı.');
    } finally {
      setLoading(false);
    }
  };

  const handleStickerClick = (sticker) => {
    setContent((prev) => prev + sticker);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="create-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Yeni Gönderi Oluştur</h3>
        <form onSubmit={handleSubmit}>
          <textarea
            placeholder="Gönderi içeriğinizi yazın..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={5}
            disabled={loading}
          />
          <div className="sticker-bar">
            {stickers.map((sticker, index) => (
              <span
                key={index}
                className="sticker"
                onClick={() => handleStickerClick(sticker)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter') handleStickerClick(sticker); }}
              >
                {sticker}
              </span>
            ))}
          </div>

          {error && <p className="error-message">{error}</p>}
          <div className="modal-buttons">
            <button type="button" onClick={onClose} disabled={loading}>İptal</button>
            <button type="submit" disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'Gönder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreatePostModal;